import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import DotLoader from './DotLoader';
import ContactPopup from '../ContactPopup/ContactPopup';

const LoadingPopup = ({ message, onContactSupport, t }) => {
  return (
    <>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '24px',
          backgroundColor: '#fff',
          borderRadius: '8px',
          boxShadow: 3,
          width: '319px',
          position: 'fixed', // Make it fixed on the page
          top: '50%', // Vertically center
          left: '50%', // Horizontally center
          transform: 'translate(-50%, -50%)', // Adjust for perfect centering
          zIndex: 9999, // Make sure it appears above other content
        }}
      >
        <Typography sx={{ fontSize: '18px', fontWeight: 600, marginBottom: '12px', color: '#12538B' }}>
          {message}
        </Typography>

        <Typography sx={{ fontSize: '14px', color: '#555', marginBottom: '16px' }}>
         {t.loadingPopup.message}<br /> {t.loadingPopup.reviewingText}
        </Typography>

        {/* Reusable DotLoader Component */}
        <DotLoader />

        <Typography sx={{ fontSize: '14px', color: '#555', marginBottom: '16px' }}>
          {t.loadingPopup.issueText}      </Typography>

        <Button
          variant="contained"
          sx={{ backgroundColor: '#0D4975', fontSize: '14px', fontWeight: 500, textTransform: "none" }}
          onClick={onContactSupport}
        >
           {t.loadingPopup.contactSupport} 
        </Button>
      </Box>
      <ContactPopup t={t}/>
    </>
  );
};

export default LoadingPopup;
